<template>
  <div class="wf-anchor-bar-item">
    <a class="wf-anchor-bar-link" :href="anchor" :class="statusClass">
      {{ title }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: String,
    anchor: String,
    anchorType: String,
  },
  data() {
    return {
      statusClass: "wf-anchor-bar-link-inactive",
      anchorTarget: document.querySelector(this.anchor),
      anchorScrollOffset: 60, // Offset equal to scroll-padding-top
    };
  },
  mounted() {
    window.addEventListener("scroll", this.updateStatusClass);
    this.updateStatusClass();
    this.scrollToAnchorIfActive();
  },
  destroyed() {
    window.removeEventListener("scroll", this.updateStatusClass);
  },
  computed: {
    ...mapGetters({
      coordinatingProducts: "productDetail/coordinatingProducts",
    }),
  },
  methods: {
    updateStatusClass() {
      // Status class is 'active' when the anchor target element's bounding rectangle intersects the top of the viewport
      if (!this.anchorTarget) {
        this.anchorTarget = document.querySelector(this.anchor);
      }

      if (this.anchorTarget) {
        const anchorTargetBounds = this.anchorTarget.getBoundingClientRect();
        const isActive =
          anchorTargetBounds.top <= this.anchorScrollOffset &&
          anchorTargetBounds.bottom > this.anchorScrollOffset;
        this.statusClass =
          "wf-anchor-bar-link-" + (isActive ? "active" : "inactive");
      }
    },
    scrollToAnchorIfActive() {
      if (this.anchorTarget && window.location.hash === this.anchor) {
        window.scrollTo(this.anchorTarget);
      }
    },
  },
};
</script>